/*@ngInject*/
const AttachmentUtil = function ($rootScope, coreMediator, coreConstant, preferenceModel, uuidUtil, dataSetUtil) {

    this.getAttachmentLinkURL = function (attachmentId, attachmentName) {
        return coreMediator.getSingleUseToken().then((token) => {
            attachmentName = null; // to avoid issues like UMS-26493, not to include attachment name for now but leave the param for future use
            const attachmentNamePath = attachmentName ? '/' + encodeURIComponent(attachmentName) : '';
            const attachmentNameParameter = attachmentName ? encodeURIComponent(' filename="' + attachmentName + '"') : '';
            const t = encodeURIComponent(token);
            return `/attachments${attachmentNamePath}?id=${attachmentId}&t=${t}&contentDisposition=inline;${attachmentNameParameter}`;
        });
    };

    this.getAttachmentTypes = function () {
        return dataSetUtil.getDataItems({name: 'Attachment Types'});
    };

    this.validateAttachment = function (uploadedFile, i18n) {
        let acceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::'),
            allowFile = this.validateAttachmentType(uploadedFile, i18n, acceptedTypes, null);

        if (allowFile) {
            let maxUploadFileSize = parseInt(preferenceModel.get('system.maxUpload'));
            if (uploadedFile.size / 1024 / 1024 > maxUploadFileSize) {
                let notificationMessage = _.get(i18n, 'maxFileSizeMessage');
                notificationMessage = _.replace(notificationMessage, '{maxSize}', maxUploadFileSize);
                $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
                    title: _.get(i18n, 'maxFileSizeTitle'),
                    summary: notificationMessage
                });
                allowFile = false;
            }
        }

        return allowFile;
    };

    this.validateAttachmentForUMStudio = function (uploadedFile, i18n) {
        let acceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::');

        return this.validateAttachmentType(uploadedFile, i18n, acceptedTypes);
    };

    this.validateAttachmentType = function (uploadedFile, i18n, acceptedTypes, globalAcceptedTypes) {
        let allowFile = false;

        if (_.isEmpty(acceptedTypes)) {
            allowFile = true;
            if (!_.isEmpty(globalAcceptedTypes)) {
                allowFile = false;
                _.each(globalAcceptedTypes, function (type) {
                    type = _.trim(type);
                    type = _.replace(type, '*.', '');
                    type = _.replace(type, '.', '');
                    if (_.endsWith(_.toLower(uploadedFile.name), `.${type}`)) {
                        allowFile = true;
                        return false;
                    }
                });
            }
        } else {
            _.each(acceptedTypes, function (type) {
                type = _.trim(type);
                type = _.replace(type, '*.', '');
                type = _.replace(type, '.', '');
                if (!_.isEmpty(globalAcceptedTypes)) {
                    _.each(globalAcceptedTypes, function (globalType) {
                        globalType = _.trim(globalType);
                        globalType = _.replace(globalType, '*.', '');
                        globalType = _.replace(globalType, '.', '');
                        if (type === globalType) {
                            if (_.endsWith(_.toLower(uploadedFile.name), `.${type}`)) {
                                allowFile = true;
                                return false;
                            }
                        }
                    });
                }else{
                    if (_.endsWith(_.toLower(uploadedFile.name), `.${type}`)) {
                        allowFile = true;
                        return false;
                    }
                }
            });
        }

        if (!allowFile) {
            let notificationMessage = _.get(i18n, 'unacceptableTypeMessage');
            notificationMessage = _.replace(notificationMessage, '{name}', uploadedFile.name);
            $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
                title: _.get(i18n, 'unacceptableTypeTitle'),
                summary: notificationMessage,
                confirmActionButtonLabel: _.get(i18n, 'unacceptableTypeConfirmActionButtonLabel')
            });
        }

        return allowFile;
    };

    this.getAttachmentPayload = function (attachment) {
        return {
            'type': attachment.type ? attachment.type : '',
            'description': attachment.description ? attachment.description : '',
            'shared': attachment.shared,
            'fileExpectedSize': attachment.size,
            'guid': attachment.guid ? attachment.guid : uuidUtil.generateUUID(),
            'kind': 0,
            'name': attachment.name,
            'nonDeletable': false
        };
    };

    this.isNewAttachmentObject = function (attachment) {
        return _.has(attachment, 'file') && _.has(attachment, 'attachment');
    };

    this.convertAttachmentSize = function (size) {
        let displaySize;
        if (size/(1024*1024) > 1) {
            displaySize = (size/(1024*1024)).toFixed(0) + 'MB';
        } else {
            displaySize = (size/(1024)).toFixed(0) + 'KB';
        }
        return displaySize;
    };

};

angular.module('umCore').service('attachmentUtil', AttachmentUtil);
